export default {
  title: 'Assurance auto et habitation',
  text: 'Économisez en moyenne 510 $ en combinant vos assurances auto et habitation.',
  link: 'Obtenir une soumission',
  closeButton: 'Fermer',
  lobAlt: 'icone ligne d\'affaires',
};
